/** The two purchase steps a scan drives on the order details page. */
export const ORDER_DETAILS_PAGE_SCAN_SUBMIT_INTENTS = {
  COMPLETE_CHECKOUT: 'COMPLETE_CHECKOUT',
  START_CHECKOUT: 'START_CHECKOUT',
} as const;
